export default __webpack_public_path__ + "static/media/polaroid18.75542486.jpg";